export default "__VITE_ASSET__DSkYhf1Y__"